import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-edit, date-edit"} maskId="square-filled-radius-0-stroke-1-IconCalendarEdit"><path d="M8 2H7V4H3V21H12V20H4V9H20V12H21V4H17V2H16V4H8V2Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M19.504 13.7968L14 19.1785V22H16.7071L22.2071 16.5L19.504 13.7968Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarEdit;
